import { types } from "../types/types";
import ContratacionesService from "../services/ContratacionesService";
import DiscapacidadService from "../services/DiscapacidadService";
import { finishSpinner, startSpinner } from "./ui/spinner";
import { handleErrorApi } from "../helpers/randoms";
import { startAlerta } from "./ui/alertas";

export const fetchNomencladorNacional = (todasLasPracticas=false, textoBusquedaCodigoNombre="") => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.contratacionesNomenclador })
    try {
        const response = await ContratacionesService.traerNomencladorNacional(todasLasPracticas, textoBusquedaCodigoNombre)
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.contratacionesNomencladorSuccess,
                payload: body,
            });
            dispatch(finishSpinner());
        } else {
            throw body
        }
    } catch (error) {
        dispatch(finishSpinner())
        dispatch({ type: types.contratacionesNomencladorError })
        handleErrorApi(dispatch, error, "Error al traer los contratos", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const fetchCuentasNomenclador = (codNom) => async (dispatch) => {
  try {
    let response;
    codNom ? 
      response = await ContratacionesService.traerCuentasNomencladorXCod(codNom) :
      response =  await ContratacionesService.traerCuentasNomenclador()
    const body = await response.json()
    if (response.ok) {
      dispatch({
        type: types.contratacionesCuentasNomencladorSuccess,
        payload: body,
      })
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesCuentasNomencladorError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las cuentas",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const fetchNomencladorIntegracion = (textoBusquedaCodigoNombre="") => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.contratacionesNomenclador })
  try {
      const response = await DiscapacidadService.traerNomencladorIntegracion(textoBusquedaCodigoNombre)
      const body = await response.json();
      if (response.ok) {
          dispatch({
              type: types.contratacionesNomencladorIntegracionSuccess,
              payload: body,
          });
          dispatch(finishSpinner());
      } else {
          throw body
      }
  } catch (error) {
      dispatch(finishSpinner())
      dispatch({ type: types.contratacionesNomencladorError })
      handleErrorApi(dispatch, error, "Error al traer las prácticas", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const savePractica = (data, handleClose, setPractica, setOpen) => async (dispatch) => {
  try {
      dispatch(startSpinner())
      let result;
      if(data.id){
        result = await ContratacionesService.editarPractica(data.id, data) 
      }else{
        result = await ContratacionesService.crearPractica(data)
      } 
      const body = await result.json()
      if (result.ok) {
          if(data.id){
            dispatch({
                type: types.contratacionesNomencladorModificar,
                payload: data,
            })
          }else{
            dispatch({
                type: types.contratacionesNomencladorGuardar,
                payload: data,
            })
            setPractica(body) 
          }
          dispatch(finishSpinner())
          handleClose()
          dispatch(startAlerta("Practica guardada correctamente", "success"))
          if(!data.id)
            setOpen(true)
      } else {
          throw body
      }
  } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al actualizar la practica", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const saveCuenta = (data, handleClose, practica) => async (dispatch) => {
  try {
      dispatch(startSpinner())
      let result;
      if(data.idcuentasNomenclador){
        result = await ContratacionesService.editarCuenta(data) 
      }else{
        
        result = await ContratacionesService.crearCuenta(
          {...data, 
            idNomenclador: practica ? practica.id : data.idNomenclador
          }) 
      }
      const body = await result.json()
      if (result.ok) {
          if(data.idcuentasNomenclador){
            dispatch({
                type: types.contratacionesCuentasNomencladorModificar,
                payload: data,
            }) 
          }else{
            dispatch({
                type: types.contratacionesCuentasNomencladorGuardar,
                payload: data,
            }) 
          }
          dispatch(finishSpinner())
          handleClose()
          dispatch(startAlerta("Cuenta guardada correctamente", "success"))
      } else {
          throw body
      }
  } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al actualizar la cuenta", "Ha ocurrido un error. Intente nuevamente") 
  }
};